<template>
  <div class="bpView">

    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="100">
        <bp-line-graph
          v-if="$store.state.user.scope"
          :userId="$store.state.user.scope.user_id"
        ></bp-line-graph>
      </mu-col>
      <!--<mu-col width="100" tablet="50" desktop="50">
        <mu-card id="pulseLayout">
          <mu-card-text>
            <mu-row>
              <mu-col desktop="33">
                <mu-icon-button icon="chevron_left" @click="filterDate('prev')" />
                <mu-icon-button icon="chevron_right" @click="filterDate('next')" :disabled="isToday"/>
              </mu-col>
              <mu-col desktop="33">
                <span class="mediumTitle" v-text="moment(date).format('Do MMM YY')"></span>
              </mu-col>
              <mu-col desktop="33">
                <mu-select-field icon="cloud_circle" v-model="selectedDevice" :maxHeight="300">
                  <mu-menu-item v-for="device, i in devices" :key="`device-${i}`" :value="device" :title="capitialize(device)" />
                </mu-select-field>
              </mu-col>
            </mu-row>
            <striiv-pulse-line-graph v-if="isStriiv" :date="date"></striiv-pulse-line-graph>
          </mu-card-text>
        </mu-card>
      </mu-col>-->
    </mu-row>

    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50">
        <!--<pulse-range style="margin-top: 24px"></pulse-range>-->
        <blood-pressure-input style="margin-top: 24px" class="card-spacing"></blood-pressure-input>
        <tracking-exporter
          type="blood-pressure"
        ></tracking-exporter>
        <tracking-notifier
          :userId="$store.state.user.scope.user_id">
        </tracking-notifier>

      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                   class="timelineSpacing">
                <div class="bold timelineTitle groupedDate"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>

              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="btnColor"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                    <mu-row>
                      <mu-col>
                        <div class="trackingDate" v-if="!item.isEditMode"
                             v-text="groupedItemDate(item.date_created)"></div>
                        <!--<div v-if="item.pulse" v-text="item.pulse + ' BPM'"></div>-->
                      </mu-col>
                      <mu-col>
                        <div v-if="!item.isEditMode" class="reading">
                          {{item.systolic}}/{{item.diastolic + ' mmHG'}}
                        </div>
                      </mu-col>
                    </mu-row>
                  </div>
                  <div v-if="item.isControlsVisible === true && !item.isEditMode">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                  <div v-if="item.isEditMode">
                    <bp-edit
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                      :item="item"
                    />
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div v-text="$t('message.loadingText')"></div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>



  import BpLineGraph from "../../components/Tracking/Graphs/BloodPressure/LineGraph.vue";
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import BloodPressureInput from "../../components/Tracking/Input/BloodPressure/BloodPressure.vue";
  import BloodPressureApi from '../../api/Tracking/BloodPressure'
  import BpEdit from "../../components/Tracking/Edit/BloodPressure/BloodPressureEdit";
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";
  import StriivPulseLineGraph from "../../components/Tracking/Graphs/Pulse/LineGraph.vue";

  import IntegrationApi from '../../api/Integrations';
  import PulseRange from "../../components/Tracking/Visualizations/Pulse/Pulse";

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  export default {
    mixins: [TrackingDetailMixin],
    components: {
      PulseRange,
      StriivPulseLineGraph,
      TrackingExporter,
      TrackingNotifier,
      BpEdit,
      BloodPressureInput,
      BpLineGraph
    },
    data() {
      return {
        devices: [],
        selectedDevice: '',
        btnColor: '#FA6957',
        date: toDate
      }
    },
    mounted() {
      let self = this;
      self.listUserDevices();

      self.date = toDate.format('YYYY-MM-DD');

      self.$gtag.pageview('/tracking/blood-pressure');
      self.loadData();

      self.$EventBus.$on('bloodPressurePusherReceived', function () {
        self.loadData();
      });

    },
    computed: {
      isToday() {
        let self = this;
        return moment().isSame(moment(self.date), 'day');
      },
      isStriiv() {
        let self = this;
        return self.selectedDevice === 'STRIIV';
      }
    },
    methods: {
      moment(date) {
        return moment(date);
      },
      filterDate(position) {
        let self = this,
            date = moment(self.date),
            newDate = null;
        if( position === 'prev' ) {
          date = date.subtract(1, "days");
          newDate = date;
        }
        if ( position === 'next' ) {
          date = date.add(1, "days");
          newDate = date;
        }
        self.date = newDate.format('YYYY-MM-DD');
      },
      capitialize(str) {
        return _.capitalize(str)
      },
      listUserDevices() {
        let self = this;
        IntegrationApi.getSubscriptions()
        .then(function (response) {
          let data = response.data;
          self.devices = data;
          self.selectedDevice = data[0];
        });
      },
      loadData() {
        let self = this;
        BloodPressureApi.getBloodPressureTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
          })
      },
      /**
       * Delete a blood pressure reading
       * @param reading
       */
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveBloodPressureItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return BloodPressureApi.deleteBloodPressureTracking(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveBloodPressureItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })

          }.bind(self))
          .catch(self.$alert.noop)
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          BloodPressureApi.getBloodPressureTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
      updateReading(item) {
        let self = this;
        let currentReading = self.data.data.filter(function (reading) {
          return reading.progress_id === item.progress_id
        })[0];

        currentReading.date_created = item.date_created;
        currentReading.systolic = item.systolic;
        currentReading.diastolic = item.diastolic;
        currentReading.pulse = item.pulse;

        self.$emit('updateGraphData');
        self.$EventBus.$emit('bloodPressureReadingUpdated');

        self.sortItems();
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('bpReadingAdded');
      this.$EventBus.$off('bloodPressurePusherReceived');
    }
  }
</script>

<style lang="less">

  @bgBranding: #FA6957;
  .bpView {
    .timelineSpacing {
      padding-top: 8px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 0px;
    }
    .timelineSpacing.notEditMode:hover {
      background: fade(@bgBranding, 15%);
    }
    #pulseLayout {
      .mediumTitle {
        display: block;
        text-align: center;
        position: relative;
        top: 7px;
      }
      .mu-text-field {
        float: right;
        width: 150px;
        height: 38px;
        border-radius: 2px;
        border: 1px solid #EBEBEB;
        &.has-icon {
          padding-left: 51px;
        }
        .mu-dropDown-menu-icon {
          right: 5px;
          top: 4px;
        }
        .mu-text-field-content {
          position: relative;
          top: 4px;
        }
        .mu-text-field-focus-line {
          display: none;
        }
      }
      .mu-text-field-line {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BloodPressure.vue?c3fd1a6c